const mockinvestments = [
  {
    projectName: "Tropical Forest Protection, Keo Seima",
    createdAt: 1694695103899,
    unit: "Tonnes CO2",
    totalInvested: 345,
    note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    projectName: "Mangrove Restoration Pakistan",
    createdAt: 1694695133605,
    unit: "Tonnes CO2",
    totalInvested: 86.1,
  },
  {
    projectName: "Kasigau Corridor REDD+ Project",
    createdAt: 1660197305538,
    unit: "Tonnes CO2",
    totalInvested: 195.01,
    note: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.",
  },
  {
    projectName: "Culm Moor Woodland Reserve",
    createdAt: 1660206225418,
    unit: "Tree(s)",
    totalInvested: 100.000251,
    note: "Short note",
  },
  {
    projectName: "Tree Planting- TIST Kenya",
    createdAt: 1710138243000,
    unit: "Tree(s)",
    totalInvested: 300,
  },
  {
    projectName: "Rimba Raya",
    createdAt: 1699683843000,
    unit: "Tonnes CO2",
    totalInvested: 456,
  },
  {
    projectName: "Mangrove Planting, Maroalika",
    createdAt: 1777978024000,
    unit: "Tree(s)",
    totalInvested: 1100,
    note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    projectName: "Seagrass Monitoring, Vanga Bay",
    createdAt: 1712138243000,
    unit: "Minutes of monitoring footage",
    totalInvested: 500,
    note: "Quarterly seagrass monitoring footage",
  },
];

export default mockinvestments;
